import React from 'react'

const Trainerwhiteicon = () => {
    return (
        <div>
            <svg width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.1814 3.86992C10.1814 6.00721 8.44878 7.73983 6.31149 7.73983C4.17419 7.73983 2.44157 6.00721 2.44157 3.86992C2.44157 1.73262 4.17419 0 6.31149 0C8.44878 0 10.1814 1.73262 10.1814 3.86992Z" fill="white" />
                <path d="M0.506941 39.6667V15.4797C0.506941 13.5447 0.278561 9.67484 2.4419 9.67482L22.7586 9.67479L22.759 13.5447H12.1167V39.6667H8.24677V27.0894H4.37686V39.6667H0.506941Z" fill="white" />
                <path d="M35.3359 1.93496H14.0513V5.80487H31.4659V23.2195H15.9863V27.0894H21.7912L25.6611 38.6992H29.531L25.6611 27.0894H35.3359V1.93496Z" fill="white" />
            </svg>

        </div>
    )
}

export default Trainerwhiteicon
